export default __webpack_public_path__ + "static/media/cancel.c0ea4236.svg";